import { AbstractControl, ValidatorFn } from '@angular/forms';

export function spacesOnly(): ValidatorFn {
	return (control: AbstractControl) => (control.value && control.value.trim() === '' ? { spacesOnly: true } : null);
}
